export default __webpack_public_path__ + "static/media/home-shop-modern-03.9419045e.jpg";